import JamezzFormStyles from "../../../../JamezzForm/JamezzFormStyles";

const OverzichtStyle = {
  ...JamezzFormStyles,
  right: {
    textAlign: "right",
  },
};

export default OverzichtStyle;
